<template>
  <div>
    <Breadcrumb v-if="!hasTarget" :links="links"></Breadcrumb>
    <Teleport v-else to=".s-breadcrumb-target">
      <Breadcrumb class="s-breadcrumb__abs-image" :links="links"></Breadcrumb>
    </Teleport>
  </div>
</template>

<script setup>
import jQuery from 'jquery'
import { nextTick, ref } from 'vue'
import { getData } from '../../lib/lib'
import Breadcrumb from '../components/Breadcrumb.vue'

const { links } = getData('breadcrumbData')

const target = jQuery('.s-breadcrumb-target')
const hasTarget = ref('')

nextTick(() => {
  hasTarget.value = ref(target.length)
})
</script>
